import React from 'react';
import {Link} from "react-router-dom";
import Header from "../header/header";
import {authenticationService} from "../scripts/authentication.service";
import Items from "../api/content";
import {Fab, Tooltip, Button, InputAdornment, TextField, LinearProgress, ToggleButton, ToggleButtonGroup, TableContainer, Table, Paper, Pagination, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import {withSnackbar} from "notistack";
import F0F from "../errors/404";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import {searchService} from "../scripts/search.service";
import '../styles/tables.css'

class Music extends React.Component {
    constructor(props) {
        super(props);

        this.searchContent = this.searchContent.bind(this)
        this.updateSearchText = this.updateSearchText.bind(this)

        this.state = {
            type: 1,
            should404: false,
            isStim: false,
            error: null,
            currentSearch: searchService.currentSearchValue.search,
            isLoaded: false,
            content: [],
            currentType: searchService.currentSearchValue.type,
            currentType3: searchService.currentSearchValue.type3,
            searchContent: [],
            loadCount: 0,
            currentPage: searchService.currentSearchValue.page,
            itemsPerPage: 10,
            currentUser: authenticationService.currentUserValue,
        };
    }

    getContent(){
        Items.getAllMusic()
            .then(result => {
                this.setState({
                    content: result,
                    searchContent: result,
                    isLoaded: true
                }, () => {
                    this.searchContent()
                });
            })
    }

    componentDidMount() {
        this.getContent();
    }

    setPage(event, value) {
        let data = searchService.currentSearchValue
        data.page = value
        searchService.setSearch(data)
        this.setState({
            currentPage: value
        })
    }

    updateSearchText(event) {
        let data = searchService.currentSearchValue
        data.search = event.target.value
        searchService.setSearch(data)
        this.setState({
            currentSearch: event.target.value
        }, () => {
            this.searchContent()
        })
    }

    updateSearchType = (event) => {
        let data = searchService.currentSearchValue
        data.type = event.target.value
        searchService.setSearch(data)
        this.setState({
            currentType: event.target.value
        }, () => {
            this.searchContent()
        })
    }

    updateSearchType3 = (event) => {
        let data = searchService.currentSearchValue
        data.type3 = event.target.value
        searchService.setSearch(data)
        this.setState({
            currentType3: event.target.value
        }, () => {
            this.searchContent()
        })
    }

    searchContent() {
        let results = this.state.content

        if (this.state.currentSearch.length !== 0) {
            results = results.filter(obj => {return obj.title.toUpperCase().includes(this.state.currentSearch.toUpperCase())})
        }

        if (this.state.currentType === "new") {
            results = results.sort(function (a,b){
                return (b.id - a.id)
            })
        }

        if (this.state.currentType === "old") {
            results = results.sort(function (a,b){
                return (a.id - b.id)
            })
        }

        if (this.state.currentType3 === "sti") {
            results = results.filter(obj => {return obj.viewabilityTracking})
        }

        if (this.state.currentType3 === "nsti") {
            results = results.filter(obj => {return !obj.viewabilityTracking})
        }

        this.setState({searchContent:results})
    }

    render() {
        const { error, isLoaded, currentPage, itemsPerPage, currentSearch, searchContent, currentType, currentType3, should404, currentUser } = this.state;
        const indexOfLastPost = currentPage * itemsPerPage;
        const indexOfFirstPost = indexOfLastPost - itemsPerPage;
        const perms = currentUser.perms

        if (should404) {
            return <F0F />
        } else {
            let currentItems = searchContent.slice(indexOfFirstPost, indexOfLastPost)

            if (error) {
                return <div>Error: {error.message}</div>;
            } else if (!isLoaded) {
                return (
                    <>
                        <Header/>
                        <div style={{width:"50%"}}>
                            <LinearProgress />
                        </div>
                    </>
                )
            } else {
                return (
                    <>
                        <Header/>

                        <div style={{position:"absolute",top:"0",left:"0",marginLeft:"50px",padding:"15px",backgroundColor:"rgba(0, 0, 0, 0.65)", display:"flex", borderRadius: "0 0 5px"}}>
                            <TextField
                                label="Search"
                                style={{marginRight:"10px"}}
                                onChange={this.updateSearchText}
                                focused
                                value={currentSearch}
                                className="foreInputWhite"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon color="primary" />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <ToggleButtonGroup
                                color="primary"
                                value={currentType}
                                exclusive
                                onChange={this.updateSearchType}
                                style={{marginLeft: "10px", border: "#1565c0 2px solid"}}
                            >
                                <ToggleButton className="testing" value="new">New</ToggleButton>
                                <ToggleButton className="testing" value="old">Old</ToggleButton>
                            </ToggleButtonGroup>
                            <ToggleButtonGroup
                                color="primary"
                                value={currentType3}
                                exclusive
                                onChange={this.updateSearchType3}
                                style={{marginLeft: "10px", border: "#1565c0 2px solid"}}
                            >
                                <ToggleButton className="testing" value="all">All</ToggleButton>
                                <ToggleButton className="testing" value="sti">Stims</ToggleButton>
                                <ToggleButton className="testing" value="nsti">Non-Stims</ToggleButton>
                            </ToggleButtonGroup>
                            <Tooltip title="Add" aria-label="add">
                                <Fab style={{marginLeft:"10px"}} color="primary" href={`/musicCont/edit/new`}>
                                    <AddIcon />
                                </Fab>
                            </Tooltip>
                        </div>

                        <TableContainer className="profiles-container" style={{width: "50%", top: "1.5rem", maxHeight: "80vh"}}>
                            <Table component={Paper} >
                                <TableHead className='table_head'>
                                    <TableRow  style={{paddingLeft: "1rem"}}>
                                    <TableCell style={{width: "10%"}}></TableCell>
                                        <TableCell className="table_cell top_row" style={{fontWeight: 600, width: "50%"}}>Title</TableCell>
                                        <TableCell className="table_cell top_row" style={{fontWeight: 600, width: "20%"}}>Date</TableCell>
                                        <TableCell className="table_cell top_row" style={{fontWeight: 600, width: "20%"}}>Edit</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {currentItems.map((item, index) => (
                                <TableRow key={item.id} className={index % 2 === 0 ? 'dark_row' : 'light_row'} >
                                    {item.status === 4 && (
                                        <div className="src-warning">
                                            <Tooltip title={"Source Error"}><GppMaybeIcon color="error" /></Tooltip>
                                        </div>
                                    )}
                                    
                                        <TableCell style={{ padding: "0.25rem 1rem 0.25rem 1rem"}}>
                                           
                                        </TableCell>
                                       
                                        <TableCell className="table_cell">
                                            <div className="hover-image" title={item.title}>
                                                {item.title}
                                                {item.src ? ( 
                                                    <div className="image-tooltip" style={{ backgroundImage: `url(${item.src}`}}></div>) : (<div className="image-tooltip" style={{fontWeight: 700, fontSize: "20px", background: "black", alignItems: "center", justifyContent: "center", padding: "20px"}}>
                                                            WHERE'S THE LAMB SAUCE
                                                        </div>  )} 
                                                
                                                  
                                            </div>
                                           
                                           
                                        </TableCell>
                                     <TableCell className="table_cell">{new Date(item.dateCreated).getDate()}/{new Date(item.dateCreated).getMonth()+1}/{new Date(item.dateCreated).getFullYear()}</TableCell>
                                    <TableCell>
                                        <Link to={perms.c2 ? `/musicCont/edit/${item.id}` : `/musicCont`}>
                                            <Button disabled={!perms.c2} variant="contained" size="small" color="secondary">
                                                Edit
                                            </Button>
                                        </Link>
                                    </TableCell>
                                        
                                 
                                </TableRow>
                            ))}
                                </TableBody>
                            </Table>
                            
                        </TableContainer>
                        <div className="pagination-container">
                            <Pagination color="secondary" count={Math.ceil(searchContent.length / itemsPerPage)} page={currentPage} onChange={(event, page) => this.setPage(event, page)} />
                        </div>
                      
                        <div style={{position: "absolute", top: 0, right: 0, padding:"0.70rem",backgroundColor:"rgba(0, 0, 0, 0.65)", borderRadius: "0 0 0 5px"}}>
                            <Link to="/"><Button style={{marginLeft: "10px"}} variant="contained" color="primary" className="spacer">Back</Button></Link>
                        </div>
                    </>
                );
            }
        }
    }
}

export default withSnackbar(Music);